// extracted by mini-css-extract-plugin
export default {"wrapper":"qz-z","viewport":"rz-z","container":"sz-z","slide":"tz-z"};